// Let the native variant picker update price, availability, URL and both selectors.
class DmStickySizes extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const bar = this.closest('.dm-product-sticky-bar');
    if (bar) {
      const updateChatOffset = () => {
        const bottom = parseFloat(getComputedStyle(bar).bottom) || 0;
        document.documentElement.style.setProperty('--dm-sticky-chat-offset', `${Math.ceil(bar.getBoundingClientRect().height + bottom + 12)}px`);
      };
      this.chatResizeObserver = new ResizeObserver(updateChatOffset);
      this.chatResizeObserver.observe(bar);
      window.addEventListener('resize', updateChatOffset, { signal: this.controller.signal });
      updateChatOffset();
    }
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-size-value]');
      if (!button) return;
      const form = document.getElementById(this.getAttribute('form'));
      const input = Array.from(form?.elements || []).find((element) =>
        element.matches('input[data-option-position]') &&
        element.value === button.dataset.sizeValue &&
        element.dataset.optionPosition === button.dataset.sizePosition
      );
      if (input && !input.disabled) input.click();
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() {
    this.controller.abort();
    this.chatResizeObserver?.disconnect();
  }
}
if (!customElements.get('dm-sticky-sizes')) customElements.define('dm-sticky-sizes', DmStickySizes);
